import type { Event } from '@sentry/react';
import { isInAppBrowserNoise } from './isInAppBrowserNoise';

const PENSAO_URL_PATTERN = /\/pensao(\/|$|\?|#)/;

export const sentryBeforeSend = (event: Event) => {
  const url = event.request?.url;
  if (url && PENSAO_URL_PATTERN.test(url)) {
    return null;
  }
  if (isInAppBrowserNoise(event)) {
    return null;
  }
  return event;
};
